module.exports = __webpack_public_path__ + "static/img/la_manicurista.46892e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platforms/la_manicurista.png
// module id = Yw/i
// module chunks = 0